import "./About.css";

const About = () => {
  return (
    <div className="about">
      <div className="inverted-bar">
        <p>Make great designs and great works</p>

        <p
          style={{
            lineHeight: "1.5em",
            fontSize: "0.8em",
            marginTop: "1em",
          }}
        >
          © 2022 Published by Halid
        </p>
      </div>
    </div>
  );
};

export default About;
